import Swiper from '../vendors/swiper.min.js';

const selectors = {
  blogCarousel: '[data-blog-carousel]',
  blogFeature: '[data-blog-feature]',
  carouselContainer: '[data-blog-carousel-container]',
  carouselScrollbar: '[data-scrollbar]',
};

const dom = {};

const cacheDom = () => {
  dom.blogFeature = document.querySelectorAll(selectors.blogFeature);
};

const handleBadgingEvents = () => {
  if (dom.blogFeature) {
    dom.blogFeature.forEach((badging) => {
      const thisBadging = badging;
      const carouselContainer = thisBadging.querySelector(
        selectors.carouselContainer,
      );
      const carouselScrollbar = thisBadging.querySelector(
        selectors.carouselScrollbar,
      );

      const swiper = new Swiper(carouselContainer, {
        breakpoints: {
          752: {
            centerInsufficientSlides: true,
            slidesPerView: 2.3,
            spaceBetween: 36,
          },
        },
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
        scrollbar: {
          draggable: true,
          el: carouselScrollbar,
        },
        slidesOffsetAfter: 24,
        slidesOffsetBefore: 24,
        slidesPerView: 1.2,
        spaceBetween: 14,
      });
    });
  }
};

const featureBlogSection = {
  init() {
    cacheDom();
    handleBadgingEvents();
  },
};

export default featureBlogSection;
